// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opened[data-v-26d93c90] {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}", ""]);
// Exports
module.exports = exports;
